import { z } from 'zod'
import type { StockRecountERPSettings } from '../../models/StockERPSettings'
import { RecountMode, DamageRecordMode } from '../../models/StockERPSettings'

export const StockRecountERPSettingsDTO = z.object({
  is_restrict_entry_nfe: z.boolean(),
  is_partial_entry_nfe: z.boolean(),
  can_edit_recounted_item: z.boolean(),
  limit_barcode_length: z.number().nullish(),
  show_nfe_product_amount: z.boolean(),
  recount_mode: z.nativeEnum(RecountMode),
  damage_record_mode: z.nativeEnum(DamageRecordMode)
})

export type StockRecountERPSettingsDTO = z.infer<typeof StockRecountERPSettingsDTO>

export function mapStockRecountERPSettingsToDTO (model: StockRecountERPSettings): StockRecountERPSettingsDTO {
  return {
    is_restrict_entry_nfe: model.isRestrictEntryNfe,
    is_partial_entry_nfe: model.isPartialEntryNfe,
    can_edit_recounted_item: model.canEditRecountedItem,
    limit_barcode_length: model.limitBarcodeLength,
    show_nfe_product_amount: model.showNfeProductAmount,
    recount_mode: model.recountMode,
    damage_record_mode: model.damageRecordMode
  }
}

export function mapDTOToStockRecountERPSettings (dto: StockRecountERPSettingsDTO): StockRecountERPSettings {
  const StockRecountERPSettings: StockRecountERPSettings = {
    isRestrictEntryNfe: dto.is_restrict_entry_nfe,
    isPartialEntryNfe: dto.is_partial_entry_nfe,
    canEditRecountedItem: dto.can_edit_recounted_item,
    limitBarcodeLength: dto.limit_barcode_length ?? 0,
    showNfeProductAmount: dto.show_nfe_product_amount,
    recountMode: dto.recount_mode,
    damageRecordMode: dto.damage_record_mode
  }

  return StockRecountERPSettings
}
